import { Pictogram, type PictogramProps } from '@amumin/ui-core';
import { computed } from '@preact/signals';

import { context } from '../state/session.js';

// Fijnslijpen van de ouderapp (7 okt 2026, docs/ux/app-fijnslijpen): geen pictogram per regel in
// een volwassen context (besluit "professioneler en rustiger": lijsten als tekst, zoals op het
// bord). Een kind dat de app zelf gebruikt (rol child) houdt het pictogram van zijn taak, wens of
// boodschap; voor ouders staat er alleen tekst. Het kiezen van een pictogram (voor het bord van de
// kinderen) blijft in de formulieren.

/** Gebruikt een kind de app (eigen login met de rol child)? */
export const kidViewer = computed(() => {
  const ctx = context.value;
  const role = ctx?.households.find((x) => x.id === ctx.active_household_id)?.role;
  return role === 'child';
});

/** Pictogram in een lijstregel: alleen voor een kind, anders niets. */
export function RowPicto(props: PictogramProps) {
  return kidViewer.value ? <Pictogram {...props} /> : null;
}
